import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { SupabaseAccountService } from "../../generic/server/supabase-account-service";

import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { ChannelName } from "../types";

export function useEnabledChannels(): UseSupabaseLoaderState<ChannelName[]> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) =>
      await new SupabaseAccountService(supabase).getEnabledChannels(account_id),
    [],
  );
}
